import { METRIC_TYPE } from '../consts/graphTypes';

export const CALCULATION_STRATEGY_SETTING_KEY =
  'calculation_strategy_per_widget';

export const getCalculationStrategyKey = (reportName = '', widgetName = '') =>
  `${(reportName || '').replace(/ /g, '_').toLowerCase()}_${(widgetName || '')
    .replace(/ /g, '_')
    .toLowerCase()}`;

//
export const getWidgetCalculationStrategyFromAccountSettings = ({
  account,
  reportName,
  widgetName,
  reportType
}) => {
  if (reportType === METRIC_TYPE.custom) {
    return null;
  }

  const accountSettings = account?.settings;
  return accountSettings?.[CALCULATION_STRATEGY_SETTING_KEY]?.[
    getCalculationStrategyKey(reportName, widgetName)
  ];
};
